const mission_contents = {
  "mission": "At the heart of this portfolio lies a commitment to craft, clarity, and continuous learning. Sandeep Kumar aims to empower teams, collaborators, and curious learners through thoughtfully designed frontend projects, real-time applications, and open API integrations.",
  "what_we_stand_for": [
    {
      "title": "Craftsmanship",
      "description": "Every line of code is written with care. From visual design to logic implementation, projects reflect attention to detail and purposeful creation.",
      "icon": "bx bx-code-alt"
    },
    {
      "title": "Learning & Sharing",
      "description": "This portfolio serves not just as a showcase, but as a platform to share knowledge, ideas, and inspirations with fellow developers and enthusiasts.",
      "icon": "bx bx-book-reader"
    },
    {
      "title": "Innovation",
      "description": "Modern technologies are explored and implemented across projects—React, Framer Motion, public APIs, and more—delivering functionality with aesthetic finesse.",
      "icon": "bx bx-bulb"
    },
    {
      "title": "Empowerment Through Simplicity",
      "description": "Designs and experiences are intuitive. Users are empowered with interfaces that guide, inform, and simplify complex interactions.",
      "icon": "bx bx-rocket"
    },
    {
      "title": "Community & Collaboration",
      "description": "This portfolio is part of a broader web community. Open to collaboration, critique, and exchange of ideas, it's a space for shared growth in digital creation.",
      "icon": "bx bx-group"
    }
  ]
}
export default mission_contents;